import {
  REQUEST_API,
  GET_RESPONSE_API,
  GET_ERROR_API
} from "./constants";

const initialState = {
  responses:[],
  isRequestPending: false,
  error: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_API: {
      return Object.assign({}, state, {isRequestPending: true, error: ''})
    }
    case GET_RESPONSE_API: {
      return Object.assign({}, state, {isRequestPending: false, responses: action.data})
    }
    case GET_ERROR_API: {
      return Object.assign({}, state, {isRequestPending: false, error: action.data})
    }
    default:
      return state;
  }
};

